/* eslint-disable prettier/prettier */
import { batch as batchedDispatch } from 'react-redux';
import { type Action } from '@reduxjs/toolkit';
import type { AppRootStore } from '@/configureStore';

interface QueudAction extends Action {
  meta: {
    queue?: boolean;
    preventDispatch?: boolean;
  };
}

/**
 * Dispatch previously queued actions from localStorage to the Redux store.
 * Clears the queue once all actions are dispatched
 *
 * @param {Object} store - The Redux store.
 * @param {string} storageKey - The key used to retrieve the action queue from localStorage.
 * @param {boolean} [options.batch=true] - When true all updates are batched, triggering a single state update,
 *                                         When false each action is dispatched separatly triggering mutiple state updates
 */
interface ReplayOptions {
  batch?: boolean;
}

export const dispatchQueuedActions = (
  dispatch: AppRootStore,
  storageKey: string,
  { batch = true }: ReplayOptions = {}
): void => {
  if(!dispatch) {
    return;
  }
  const queue = JSON.parse(localStorage.getItem(storageKey) || '[]');


  const actions = queue
    .map((action: QueudAction) => {
      // Delete these properties to prevent them ending up in the queue again
      delete action.meta?.queue;
      delete action?.meta?.preventDispatch;

      dispatch(action);
      return undefined;
    })
    .filter(Boolean);

  if (batch) {
    batchedDispatch(() => {
      actions.forEach((action: QueudAction) => dispatch(action));
    });
  } else {
    actions.forEach((action: QueudAction) =>dispatch(action));
  }

  localStorage.removeItem(storageKey);
};
